import { render, staticRenderFns } from "./worldMapSimple.vue?vue&type=template&id=0bfff499&"
import script from "./worldMapSimple.vue?vue&type=script&lang=js&"
export * from "./worldMapSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports